import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserHelperService } from '@core/services/browser-helper.service';
import { DeviceDetectionService } from '@core/services/device-detection.service';
import { ButtonComponent } from "../button/button.component";
import { environment } from '@environments/environment';
@Component({
  selector: 'app-recommended-browser',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './recommended-browser.component.html',
  styleUrls: ['./recommended-browser.component.scss']
})
export class RecommendedBrowserComponent implements OnInit {
  currentUrl = environment.app.appUrl;

  constructor(
    private browserHelper: BrowserHelperService,
  ) { }

  ngOnInit() {

  }

  copyUrl() {
    this.browserHelper['copyToClipboard'](this.currentUrl);
  }
}